var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/wallet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M90.8047 22.3996L86.6013 22.7358L22.5061 27.8635C23.1717 27.5646 23.8707 27.3545 24.5869 27.2517C24.5876 27.2516 24.5883 27.2515 24.589 27.2514L84.8312 18.6479L90.8047 22.3996ZM90.8047 22.3996C90.1319 19.7825 87.7891 18.2273 84.8329 18.6477L90.8047 22.3996ZM17 95.9999V40.9999H21H96C97.8565 40.9999 99.637 41.7374 100.95 43.0502L104.485 39.5146L100.95 43.0502C102.263 44.3629 103 46.1434 103 47.9999V95.9999C103 97.8564 102.263 99.6369 100.95 100.95C99.637 102.262 97.8565 103 96 103H24C22.1435 103 20.363 102.262 19.0503 100.95C17.7375 99.6369 17 97.8564 17 95.9999ZM77.1047 59.128L80.639 62.6647L77.1047 59.128C75.8039 60.4279 74.772 61.9712 74.0677 63.6699C73.3634 65.3686 73.0006 67.1894 73 69.0282C72.9994 70.8671 73.361 72.6882 74.0641 74.3873C74.7673 76.0865 75.7982 77.6305 77.0981 78.9312C78.3979 80.232 79.9413 81.2639 81.64 81.9682C83.3387 82.6725 85.1595 83.0353 86.9983 83.0359C90.7122 83.0371 94.2744 81.563 96.9013 78.9378C99.5283 76.3126 101.005 72.7514 101.006 69.0376C101.007 65.3238 99.5331 61.7616 96.9079 59.1346C94.2827 56.5076 90.7215 55.0312 87.0077 55.0299C85.1688 55.0293 83.3478 55.3909 81.6486 56.094C79.9494 56.7972 78.4054 57.8281 77.1047 59.128Z",
    fill: "url(#paint0_linear_421_8798)",
    stroke: "url(#paint1_linear_421_8798)",
    strokeWidth: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_421_8798",
    x1: 4.94955,
    y1: 13.5791,
    x2: 106.41,
    y2: 109.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_421_8798",
    x1: 4.94955,
    y1: 13.5791,
    x2: 106.41,
    y2: 109.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoAccounts);
export default __webpack_public_path__ + "static/media/icon_no_accounts.29377f0c65e06dde0455a340f052cf52.svg";
export { ForwardRef as ReactComponent };